export default __webpack_public_path__ + "static/media/dmWorld.8657e8cb.png";